import { createSlice } from '@reduxjs/toolkit';

import { userLoggedIn } from 'store/appThunks';
import { REFERRING_CLINIC_SLICE_NAME } from 'store/slices/slicesNames';

const initialState = {
  referringClinic: localStorage.getItem('referringClinic'),
};

function updateReferringClinic(state, clinic) {
  state.referringClinic = clinic;
  localStorage.setItem('referringClinic', clinic);
}

const referringClinicSlice = createSlice({
  name: REFERRING_CLINIC_SLICE_NAME,
  initialState,
  reducers: {
    setReferringClinic(state, action) {
      updateReferringClinic(state, action.payload);
    },
  },
  extraReducers(builder) {
    builder.addCase(userLoggedIn.fulfilled, (state, action) => {
      const { referringClinic } = action.payload;
      if (referringClinic) {
        updateReferringClinic(state, referringClinic);
      }
    });
  },
});

export default referringClinicSlice;
export const { setReferringClinic } = referringClinicSlice.actions;
